import {setNestedValue} from "@Common/utils/arr-path";
import {entries}        from "@Common/utils/objects";

// changedItems is not mutated
// bindingData is not mutated
// overrideData is not mutated, but is changed and returned
export const setOverrideData = async (changedItems, product, bindingData, overrideData = {}) => {
    let changedTextItems = []
    let productModel = await product.getProductModel();
    let items = await productModel.getAllItems();
    items.forEach((item)=>{
        let itemSurface = item["_parentContainer"]["parentComponent"]["_name"];
        entries(changedItems).forEach(([surface, values])=>{
            if(values?.texts && Array.isArray(values.texts) && surface == itemSurface){
                values.texts.forEach((textField)=>{
                    if(textField.name == item._name){
                        changedTextItems.push(item);
                    }
                });
            }
        });
    });
    changedTextItems?.forEach((item)=>{
        try{
            const itemSurface = item["_parentContainer"]["parentComponent"]["_name"];
            const bindingValue = bindingData[itemSurface]?.[item._name];
            if (bindingValue?.['type'] === 'standardVariable') {
                const path = bindingValue["value"].substring(2, bindingValue["value"].length - 2);
                overrideData = setNestedValue(overrideData, path.split('.'), item["_text"]);
            }
        }
        catch (e) {
            console.log("Error with override data for item: ", item);
            console.error(e);
        }
    });
    return overrideData;
};